import dynamic from 'next/dynamic';
import Image from 'next/future/image';

const FootPrintBlogs = dynamic(() => import('./footprint'));
const MeetTeamCard = dynamic(() => import('./meet-team'));
const BlogsWithLoadMore = dynamic(
  () => import('../blog-content/blogs-with-loadmore')
);
const PassionateCard = dynamic(() => import('./passionate-card'));

const Community = (props: any) => {
  const coreValuesTitle = props?.communityData?.attributes?.Section[2]?.Title;
  const coreValuesData = props?.communityData?.attributes?.Section[3]?.Cards;
  const footPrintTitle = props?.communityData?.attributes?.Section[4].Title;
  const communityTitle = props?.communityData?.attributes?.Section[5].Title;
  const meetTitle = props?.communityData?.attributes?.Section[6].Title;
  const meetTeamData = props?.communityData?.attributes?.Section[7].Cards;

  return (
    <div className="sv-page-content community-giving-wrapper">
      <div className="container-xl custom-container px-0">
        <section className="hero-section">
          <div className="hero-banner">
            <Image
              sizes="(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 768px, (max-width: 992px) 992px, (max-width: 1280px) 1280px"
              className="banner-img"
              src={
                props?.communityData?.attributes?.Section[0]?.Background_Image
                  ?.data?.attributes?.url || ''
              }
              width="1280"
              alt={
                props?.communityData?.attributes?.Section[0]?.Background_Image
                  ?.data?.attributes?.alternativeText || ''
              }
              height="516"
            />

            <div className="banner-content">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 m-auto">
                    <h1>
                      {props?.communityData?.attributes?.Section[0]?.Title}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="promotion-banner">
            <p>{props?.communityData?.attributes?.Section[1]?.Title}</p>
          </div>
        </section>
      </div>

      <PassionateCard
        coreValuesData={coreValuesData}
        coreValuesTitle={coreValuesTitle}
      ></PassionateCard>
      <FootPrintBlogs
        blogs={props.footprintBlogsData}
        title={footPrintTitle}
      ></FootPrintBlogs>
      <BlogsWithLoadMore
        blogs={props.communityBlogsData}
        title={communityTitle}
        initSize={6}
        loadMoreSize={6}
      />
      <MeetTeamCard
        meetTitle={meetTitle}
        meetTeamData={meetTeamData}
      ></MeetTeamCard>
    </div>
  );
};

export default Community;
